module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAVElEQVRYR+3VQQ0AIQxE0RlNeAJNiyc0lYQTGGj38GtgJq9pahWPi/NFAQQQQAABBI5ARHRJLfkxLdvzLvAlFxi/K1C3gmT6J44zRAABBBBAoFxgA6HsFCEwuzdYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/减号.png
// module id = E54U
// module chunks = 171